<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">检查表列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训项目">
          <el-input v-model="formInline.train_name" clearable placeholder="请输入实训项目"></el-input>
        </el-form-item> -->

        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建检查表</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="name" label="检查表名" width="160">
      </custom-table-column>
      <custom-table-column label="状态" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.status=='1'" style="color:var(--ligtGreen);">已生效</span>
          <span v-if="scope.row.status=='0'" style="color:var(--red);">未生效</span>
        </template>
      </custom-table-column>
      <custom-table-column prop="creator_structure" label="定量" width="160">
      </custom-table-column>
      <custom-table-column prop="desc" label="备注" min-width="200">
      </custom-table-column>
      <custom-table-column prop="display_order" label="排序" width="100">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" :width="type=='edit'?'1024px':'724px'">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="检查表名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入检查表名" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="制定单位" prop="creator_structure">
          <el-input v-model="ruleForm.creator_structure" placeholder="请输入制定单位" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="定  量" prop="check_attr">
          <el-input v-model="ruleForm.check_attr" placeholder="请输入定量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="状  态" prop="status">
          <el-select v-model="ruleForm.status" clearable placeholder="请选择状态" style="width:216px;">
            <el-option v-for="item in $store.state.isEffect" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排  序" prop="display_order">
          <el-input v-model.number="ruleForm.display_order" placeholder="请输入排序" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="备  注" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
      <div v-if="type=='edit'" style="box-shadow: rgb(229 229 229) 0px 0px 1px 1px;padding:8px;width:100%;overflow: auto;box-sizing: border-box;">
        <div>
          <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
            <el-form-item>
              <el-button type="primary" @click="handleAddItem">新建检查表项目</el-button>
            </el-form-item>
          </el-form>
        </div>
        <custom-table :data="tableData1" ref="table" border style="width: 100%">
          <custom-table-column prop="cate" label="分类" width="160">
          </custom-table-column>
          <custom-table-column prop="title" label="检查项目" min-width="200">
          </custom-table-column>
          <custom-table-column prop="content" label="检查标准" min-width="200">
          </custom-table-column>
          <custom-table-column prop="level" label="隐患等级" width="80">
          </custom-table-column>
          <custom-table-column prop="score" label="分值" width="80">
          </custom-table-column>
          <custom-table-column prop="display_order" label="排序" width="80">
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="handleEditItem(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDeletItem(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <!-- <div class="pageLine">
          <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
        </div> -->
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="itemTitle" :visible.sync="innerDialogVisible" width="724px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分  类" prop="cate">
          <!-- <el-input v-model="ruleForm1.cate" placeholder="请输入检查表名" style="width:216px;"></el-input> -->
          <el-cascader v-model="cascaderVal" ref="cascader" :props="props" style="width:532px;" clearable :options="$store.state.standardList" @change="handleChangeCascader"></el-cascader>
        </el-form-item>
        <el-form-item label="检查项目" prop="title">
          <el-select v-model="selectVal" placeholder="请选择检查项目" style="width:532px;" @change="handleChange">
            <el-option v-for="item in checkItems" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查标准" prop="content">
          <el-input v-model="ruleForm1.content" readonly placeholder="请输入检查标准" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="隐患级别" prop="level">
          <el-select v-model="ruleForm1.level" placeholder="请选择隐患级别" style="width:216px;">
            <el-option v-for="item in $store.state.darkLevel" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分值" prop="score">
          <el-input-number v-model="ruleForm1.score" placeholder="请输入分值" :min="0"  style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="排  序" prop="display_order">
          <el-input v-model.number="ruleForm1.display_order" placeholder="请输入排序" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="typee=='add'" @click="submitFormByFun('ruleForm1',addCheckItem)">确认</el-button>
          <el-button type="primary" v-if="typee=='edit'" @click="submitFormByFun('ruleForm1',updateCheckItem)">编辑</el-button>
          <el-button @click="resetItemForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      props: {
        label: 'name',
      },
      itemTitle: '',
      ruleForm1: {
        cate: '',
        title: '',
        content: '',
        level: '',
        score: 0,
        display_order: 0,
      },
      typee: 'add',
      rules1: {
        cate: [{ required: true, message: '请选择分类', trigger: 'change' }],
        title: [{ required: true, message: '请选择项目', trigger: 'change' }],
        content: [{ required: true, message: '请输入检查标准', trigger: 'blur' }],
        level: [{ required: true, message: '请选择隐患级别', trigger: 'change' }],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        display_order: [{ type: 'number', message: '排序必须为数字值' }],
      },
      itemDialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      innerDialogVisible: false,
      formInline: {
        structure_1: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },
      formInline1: {},
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        name: '',
        creator_structure: '',
        check_attr: '',
        desc: '',
        status: 0,
        display_order: 0,
      },
      rules: {
        name: [{ required: true, message: '请输入检查表名', trigger: 'blur' }],
        creator_structure: [{ required: true, message: '请输入制定单位', trigger: 'blur' }],
        check_attr: [{ required: true, message: '请输入定量', trigger: 'blur' }],
        display_order: [{ type: 'number', message: '排序必须为数字值' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      cascaderVal: '',
      selectVal: '',
      checkItems: [],
      type: 'add',
      title: '新增',
      tableName: '实训日志',
      treeArr: [],
      tableArr: [],
      allArr: [],
      currentNode: null,
      tableData1: [],
      tableDetail: null,
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getStandards');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleChangeCascader(value) {
      // console.log(value);
      // console.log(this.$refs.cascader.getCheckedNodes(true));
      if (value && value.length) {
        if (value.length == 2) {
          this.ruleForm1.cate = value[1];
        }
        this.checkItems = this.$refs.cascader.getCheckedNodes(true)[0].data.list ? this.$refs.cascader.getCheckedNodes(true)[0].data.list : [];
      } else {
        this.checkItems = [];
      }
      this.selectVal = '';
      this.ruleForm1.title = '';
      this.ruleForm1.content = '';
    },
    resetItemForm(formName) {
      this.$refs[formName].resetFields();
      this.cascaderVal = '';
      this.selectVal = '';
    },
    handleChange(value) {
      // console.log(value);
      this.ruleForm1.title = value.name ? value.name : '';
      this.ruleForm1.content = value.value ? value.value : '';
      // console.log(this.$refs.cascader.getCheckedNodes(true));
    },
    handleDeletItem(id) {
      this.confirmBox('warning', `此操作将删除该项目，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/form/item/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.getItemList();
      }
    },
    handleNodeClick(nodeData) {
      console.log(nodeData);
      this.currentNode = nodeData;
      this.tableData = [];
      if (nodeData.children) {
        nodeData.children.map((item) => {
          if (item.list) {
            this.tableData = this.tableData.concat(item.list);
          }
        });
      }
      if (nodeData.list) {
        this.tableData = nodeData.list;
      }
    },
    handleAddItem() {
      this.innerDialogVisible = true;
      this.typee = 'add';
      this.itemTitle = '新增检查项目';
    },
    handleEdit(row, filterArr = ['create_at', 'school_id']) {
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.tableData1 = [];
      this.tableId = row.id;
      this.getItemList();
      this.centerDialogVisible = true;
    },
    handleEditItem(row, filterArr = ['school_id']) {
      this.typee = 'edit';
      this.itemTitle = '编辑检查项目';
      this.ruleForm1 = this.$until.delProp(row, filterArr);
      this.cascaderVal = row.cate;
      this.$nextTick(() => {
        this.checkItems = this.$refs.cascader.getCheckedNodes(true)[0].data.list ? this.$refs.cascader.getCheckedNodes(true)[0].data.list : [];
      });
      this.selectVal = row.title;
      this.innerDialogVisible = true;
    },
    async getItemList() {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/form/detail/${this.tableId}`, 'get', {});
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData1 = res.data.items;
      }
    },
    handleNode() {
      console.log(this.currentNode);
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/safety_check/form/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/safety_check/form/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async addCheckItem() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/form/item/add/${this.tableId}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加项目成功！',
        });
        this.clearState1();
      }
    },
    async updateCheckItem() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/form/item/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑项目成功！',
        });
        this.clearState1();
      }
    },
    clearState1() {
      this.resetForm('ruleForm1');
      this.ruleForm1 = {
        name: '',
        creator_structure: '',
        check_attr: '',
        desc: '',
        status: 0,
        display_order: 0,
      };
      this.innerDialogVisible = false;
      this.getItemList();
      this.cascaderVal = '';
      this.selectVal = '';
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/form/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
